import { render, staticRenderFns } from "./Backtop.vue?vue&type=template&id=67f46ee2&scoped=true&"
import script from "./Backtop.vue?vue&type=script&lang=js&"
export * from "./Backtop.vue?vue&type=script&lang=js&"
import style0 from "./Backtop.vue?vue&type=style&index=0&id=67f46ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f46ee2",
  null
  
)

export default component.exports